import { PkBadge, PkBottomPanel, PkButton, PkIcon, PkToast, PkToastItem } from '@uefadigital/panenka-react';
import { memo, useEffect, useRef, useState } from 'react';

import { useTeam, useTeamInterestOptions } from '../../store';
import { clickTracking } from '../../utils/tracking';

import PreferenceServiceInstance, { FavSource } from '@services/PreferenceService';
import { useTranslateFn } from '@shared/Translate';

import * as styles from '../styles.module.scss';

const Logged = () => {
  const t = useTranslateFn();
  const { options } = useTeamInterestOptions();
  const panelRef = useRef<HTMLPkBottomPanelElement>(null);
  const { team, status, setStatus } = useTeam();
  const [handleClose, setHandleClose] = useState(true);
  useEffect(() => {
    !handleClose && closeDialogByButton();
  }, [handleClose]);

  useEffect(() => {
    clickTracking('save fav team', 'Dialog - Loaded', 'panel_dialog_main_loaded');
  }, []);

  const saveFavTeam = () => {
    setStatus('saved');
    PreferenceServiceInstance.storePreferredTeam(team, FavSource.DIALOG);
    clickTracking('fav team added', 'Toast - Loaded', 'toast_loaded');
  };

  const trackDownload = () => {
    clickTracking('fav team added', 'Toast - Main action', 'toast_action');
  };

  const closeDialog = () => {
    handleClose && clickTracking('save fav team', 'Dialog - Skip', 'panel_dialog_skip');
  };

  const closeDialogByButton = () => {
    clickTracking('save fav team', 'Dialog - Secondary action', 'panel_dialog_secondary_action');
    panelRef.current.close();
  };

  const handleClick = () => {
    setHandleClose(false);
  };

  useEffect(() => {
    status === 'saved' && panelRef.current.close();
  }, [status]);

  const prefTeam = PreferenceServiceInstance.retrievePreferredTeam();
  if (!team || prefTeam) return;

  return (
    <>
      <PkBottomPanel ref={panelRef} focusOnOpen onPkClose={closeDialog} opened>
        <div slot='title' className='pk-d--flex pk-mb--0'>
          <PkBadge
            alt={team.displayName}
            slot='badge'
            badge-title={team.displayName}
            fallbackImage='club-generic-badge'
            size={48}
            src={team.logoUrl}
          />
          <div className='pk-d--flex pk-flex--column pk-ml--m'>
            <div className={styles.panelTitle}>{t('quick_access_to_team', { replace: [team.displayName] })}</div>
            <div className={styles.panelSummary}>{t('save_team_summary')}</div>
          </div>
        </div>

        <div slot='actions'>
          <PkButton className='pk-w--100' onPkClick={saveFavTeam}>
            {t('save_team_as_favourite', { replace: [team.displayName] })}
          </PkButton>
          <PkButton
            aria-label={t('not_now')}
            className='pk-w--100 pk-mt--m'
            onPkClick={handleClick}
            appearance='outlined'
          >
            {t('not_now')}
          </PkButton>
        </div>
      </PkBottomPanel>
      {status === 'saved' && (
        <PkToast className='pk-position--relative'>
          <PkToastItem
            appearance='success'
            borderColor=''
            bgColor=''
            autodismiss={false}
            closeButton
            dismissDelay={3000}
            className={styles.panelToastItem}
          >
            <div slot='icon'>
              <PkIcon
                name='actions-check-circle'
                role='img'
                title={t('saved_team_as_favourite', { replace: [team.displayName] })}
              />
            </div>
            <div slot='title'>{t('saved_team_as_favourite', { replace: [team.displayName] })}</div>
            <div slot='body'>
              {t('get_the_app_fastest', { replace: [team.appDownloadUrl] })}
              <a
                href={options.appDownloadUrl}
                title={t('download_the_app')}
                onClick={trackDownload}
                className='pk-d--block'
              >
                {t('download_the _app')}
              </a>
            </div>
            <div slot='message' />
          </PkToastItem>
        </PkToast>
      )}
    </>
  );
};

export default memo(Logged);
